module.exports = __webpack_public_path__ + "static/media/content-properties-icon-green.ef6db3dc.svg";